{
  "auth": {
    "logoAlt": "Smart Word Labs",
    "checkEmail": {
      "title": "请查收您的邮箱",
      "confirmationBody": "我们已向 <strong>{{email}}</strong> 发送了确认链接。请确认以激活您的账户，然后登录。",
      "magicLinkBody": "我们已向 <strong>{{email}}</strong> 发送了一次性登录链接。请在此设备上打开以登录。",
      "backToSignIn": "返回家长登录"
    },
    "heading": {
      "magicMode": "魔法链接登录",
      "signup": "创建您的家长账户",
      "signin": "家长登录"
    },
    "subheading": {
      "magicMode": "输入您的邮箱，我们将发送一次性登录链接。",
      "signup": "在一处管理孩子的课程、账单和学习进度。",
      "signin": "登录您的家长门户。"
    },
    "social": {
      "google": "使用 Google 继续",
      "apple": "使用 Apple 继续"
    },
    "or": "或",
    "fields": {
      "email": "邮箱",
      "password": "密码",
      "fullName": "全名",
      "country": "国家",
      "phone": "电话"
    },
    "buttons": {
      "pleaseWait": "请稍候…",
      "sendMagicLink": "发送魔法链接",
      "createAccount": "创建账户",
      "signIn": "登录"
    },
    "toggle": {
      "useMagicLink": "改用魔法链接登录",
      "usePassword": "改用邮箱和密码登录"
    },
    "footer": {
      "haveAccount": "已经有账户了？",
      "signIn": "登录",
      "newHere": "初次使用 Smart Word Labs？",
      "bookAssessment": "预约免费测评"
    },
    "errors": {
      "couldNotSignIn": "无法登录",
      "enterEmailFirst": "请先输入您的邮箱",
      "somethingWentWrong": "出了点问题"
    },
    "toasts": {
      "magicLinkSent": "登录链接已发送 — 请查收您的邮箱"
    }
  },
  "reviews": {
    "title": "家长评价",
    "description": "来自在 Smart Word Labs 学习的家庭的真实反馈。请在下方分享您自己的体验——评价经过审核后将显示在此处。",
    "starsAriaLabel": "{{rating}} 分（满分5分）",
    "starPickerAriaLabel": "星级评分",
    "starAriaLabel": "{{count}} 星",
    "starAriaLabel_plural": "{{count}} 星",
    "whatParentsSay": "家长怎么说",
    "empty": "暂无已发布的评价——您的评价可能是第一条。",
    "form": {
      "title": "撰写评价",
      "yourRating": "您的评分",
      "yourName": "您的姓名",
      "email": "邮箱（可选，不会公开）",
      "childAge": "孩子的年龄（可选）",
      "location": "所在城市/国家（可选）",
      "yourReview": "您的评价",
      "bodyPlaceholder": "您的孩子有什么变化？您最看重课程的哪一点？",
      "website": "网站",
      "submit": "提交评价"
    },
    "sent": {
      "title": "评价已收到",
      "body": "感谢您分享您的体验。我们会在简单审核后发布评价。",
      "writeAnother": "再写一条评价"
    },
    "errors": {
      "chooseRating": "请选择星级评分。",
      "tooFast": "太快了！请稍等片刻后重试。",
      "bodyTooShort": "请至少写几句话。",
      "checkForm": "请检查表单内容",
      "saveFailed": "无法保存您的评价，请重试。"
    },
    "toasts": {
      "submitted": "谢谢——您的评价已提交待审核。"
    }
  }
}
